import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navigation.css';

const Navigation = ({ onQRClick }) => {
  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          Reels
        </Link>
        <ul className="nav-menu">
          <li className="nav-item">
            <button className="nav-link qr-btn" onClick={onQRClick}>
              Scan QR
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
